<template>
  <div class="main-authentication">
    <div class="login-box box-auth">
      <div v-if="isBanned" class="alert alert-danger alert-danger2 text-center" role="alert">
        {{ banMessage }}
      </div>

      <img v-if="monenco" src="@/assets/images/monencogroup-logo.png" alt="logo">
      <img v-else src="@/assets/images/logo.png" alt="logo">

      <h2>ورود</h2>
      <span>لطفا {{ title }} خود را وارد کنید.</span>
      <form  @submit.prevent="getMobile">
        <div class="input" @keydown.enter="getMobile">
          <label>
            {{ title }}
          </label>
          <input :disabled="isBanned" @input="normalizeNumber" type="text" :placeholder="placeholder" v-model="mobile">
        </div>
        <v-btn :disabled="isBanned" type="submit" :loading="loading" class="btn btn-save">ورود</v-btn>

      </form>
      <div v-if="Object.keys(errors).length > 0" class="alert w-100 alert-danger mt-3 mb-0" role="alert">
        <div v-for="(err,index) in errors" :key="index">
          <span class="text-left" v-for="(msg,i) in err" :key="i">{{ index }} : {{ msg }}</span>
        </div>
      </div>

    </div>

  </div>
</template>

<script>


import store from "@/store";
import {useUserStore} from "@/store/user";

export default {
  name: "LoginComponent",
  data() {
    return {
      apiUrl: store.getters.baseUrl,
      apiBaseUrl: window.appConfig.API_URL_BASE,
      monenco: window.appConfig.monenco,
      mobile: '',
      placeholder: '0912 1234567',
      title: 'شماره موبایل',
      loading: false,
      errors: {},
      snackbar: false,
      textSnack: '',
      colorSnack: '',
      userStore :useUserStore()
    };
  },
  computed: {
    isBanned() {
      return this.userStore.ban
    },
    banMessage() {
      return this.userStore.banMsg || 'حساب شما مسدود شده است'
    }
  },
  watch: {
    showRows: {
      handler(val) {
        let data = JSON.stringify(val)
        localStorage.setItem('options-logs', data)
      },
      deep: true
    },
  },
  methods: {
    isValidIranianMobile(phone) {
      phone = phone.trim();
      const pattern = /^09\d{9}$/;
      return pattern.test(phone);
    },
    normalizeNumber() {
      if (!window.appConfig.hosted) {
        const persian = [/۰/g, /۱/g, /۲/g, /۳/g, /۴/g, /۵/g, /۶/g, /۷/g, /۸/g, /۹/g];
        const arabic = [/٠/g, /١/g, /٢/g, /٣/g, /٤/g, /٥/g, /٦/g, /٧/g, /٨/g, /٩/g];

        let value = this.mobile;

        for (let i = 0; i < 10; i++) {
          value = value.replace(persian[i], i).replace(arabic[i], i);
        }

        value = value.replace(/[^0-9]/g, '');

        this.mobile = value;
        if (this.mobile.length === 11) {
          this.getMobile()

        }
      }

    },
    getMobile() {
      if (!window.appConfig.hosted) {
        if (!this.isValidIranianMobile(this.mobile)) {
          this.showMsg('شماره موبایل را به درستی وارد کنید', 'red')

          return;
        }
      }

      store.commit('setMobile', this.mobile)
      this.$router.push('/auth/password')
 /*     this.loading = true
      axios.post(this.apiBaseUrl + 'api/verify-username',
          {username: this.mobile},
          {headers: this.headers})
          .then(res => {
            this.loading = false
            let result = res.data.result

            if (result === 1) {
              this.$router.push('/auth/password')
            } else if (result === 2) {
              this.$router.push('/auth/choice-password')
            } else {
              this.showMsg('چنین کاربری یافت نشد', 'red')
            }
          }).catch(err => {
        this.loading = false
        if (!err?.response) {
          this.showMsg('اینترنت خود را بررسی کرده و مجدد  تلاش کنید!', 'red')
          return
        }
        this.errors = err?.response?.data?.errors

      })*/

    },
    showMsg(msg, color) {
      this.$store.dispatch("snackbar/show", {
        text: msg,
        color: color
      })
    },
  },
  mounted() {
    this.mobile = store.getters.getMobile
    const userStore = useUserStore()
    console.log('userStore.ban',userStore.ban)
  },
  created() {

    if (window.appConfig.hosted) {
      this.placeholder = ''
      this.title = 'نام کاربری'

    }
  }

};
</script>

<style scoped lang="scss">
.alert-danger:not(.alert-danger2) {
  direction: ltr;
  text-align: left;
}


</style>
